import { useState, useEffect } from "react";

const useFirebaseUserDoc = ({ user, db }) => {
  const [userDoc, setUserDoc] = useState(null);

  useEffect(() => {
    if (user) {
      // save the user to the users collection
      const { uid, displayName, photoURL, email } = user;
      const { creationTime, lastSignInTime } = user.metadata;

      const userDoc = db.collection("users").doc(user.uid);
      setUserDoc(userDoc);

      userDoc.set({
        uid,
        displayName,
        photoURL,
        email,
        creationTime: new Date(creationTime),
        lastSignInTime: new Date(lastSignInTime),
      });
    } else {
      setUserDoc(null);
    }
  }, [user]);

  return userDoc;
};

export default useFirebaseUserDoc;
